import { Col, Container, Row } from "react-bootstrap";
import ScrapeEntryForm from "../../../Components/Forms/ScrapeEntryForm/ScrapeEntryForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useEditScrapeEntryMutation, useGetScrapeEntryByIdQuery } from "../../../services/bClientApi";
import { useParams } from "react-router-dom";

export default function EditScrapeEntryPage() {

    const { scrapeEntryId = '' } = useParams()

    const {
        data,
        error,
        isLoading
    } = useGetScrapeEntryByIdQuery(scrapeEntryId, { skip: !scrapeEntryId })
    const scrapeEntryData = data || {}

    const [
        editScrapeEntry,
        {
            isLoading: isLoadingEdit,
            error: editError
        }
    ] = useEditScrapeEntryMutation()

    const dispatch = useAppDispatch()
    const handleSubmit = async (data: any) => {
        const values: any = {
            ...data
        }
        const updatedScrapeEntry = await editScrapeEntry({
            scrapeEntryId: scrapeEntryId,
            scrapeEntryInfo: values
        }).unwrap()
        if (updatedScrapeEntry._id) {
            dispatch(navigateTo(`/scrape-entry/${updatedScrapeEntry._id}`))
        }
        return updatedScrapeEntry
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Edit Scrape Entry</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {editError && (<>{JSON.stringify(editError)}<br /></>)}

                    {scrapeEntryId && scrapeEntryData && !isLoading && (
                        <ScrapeEntryForm
                            initialValues={{
                                ...scrapeEntryData,
                            }}
                            disabled={isLoading || isLoadingEdit}
                            onSubmit={handleSubmit}
                        />
                    )}

                </Col>
            </Row>
        </Container>
    )
}